import React, { useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  SelectChangeEvent,
  ListItemText,
} from '@mui/material';
import HttpsRoundedIcon from '@mui/icons-material/HttpsRounded';
import { COLOR_TEXT_1 } from 'src/utils/colors';
import { COLOR_PRIMARY } from 'src/utils/const';

const BEDROOM_OPTIONS = ['All', 'Studio', '1', '2', '3', '4', '5', '6+'];

interface BedroomFilterProps {
  selectedBedroom: string;
  onChange: (selected: string) => void;
  isFreeUser: boolean;
  handleOnSampleClick: (plan: string) => void;
}

const BedroomFilter: React.FC<BedroomFilterProps> = ({
  selectedBedroom,
  onChange,
  isFreeUser,
  handleOnSampleClick,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    if (isFreeUser) {
      handleOnSampleClick('expert');
      return;
    }

    const valueFromSelect = event.target.value as string;
    onChange(valueFromSelect);
  };

  useEffect(() => {
    if (!selectedBedroom) {
      onChange('All');
    }
  }, [selectedBedroom, onChange]);

  return (
    <FormControl sx={{ width: 120 }} size="small">
      <InputLabel id="bedroom-filter-label">Bedrooms</InputLabel>
      <Select
        labelId="bedroom-filter-label"
        id="bedroom-filter-select"
        value={selectedBedroom}
        onChange={handleChange}
        input={<OutlinedInput label="Bedrooms" size="small" />}
        renderValue={selected => selected as string}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 224,
            },
          },
        }}
      >
        {BEDROOM_OPTIONS.map(option => (
          <MenuItem key={option} value={option}>
            <ListItemText
              primary={
                <>
                  {option}{' '}
                  {isFreeUser && (
                    <HttpsRoundedIcon sx={{ fontSize: '14px', color: COLOR_PRIMARY }} />
                  )}
                </>
              }
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BedroomFilter;
